import React from 'react';
import PropTypes from 'prop-types';
import { Button as AbyssButton } from '@abyss/ui/base/Button';

export const Button = ({
  children,
  variant,
  color,
  colorHover,
  linkColor,
  altColor,
  altColorHover,
  borderRadius,
  borderWidth,
  ...props
}) => {
  if (variant === 'link') {
    return (
      <AbyssButton
        {...props}
        variant={variant}
        color={linkColor}
        colorHover={linkColor}
      >
        {children}
      </AbyssButton>
    );
  }
  return (
    <AbyssButton
      {...props}
      variant={variant}
      color={color}
      colorHover={colorHover}
      altColor={altColor}
      altColorHover={altColorHover}
      borderRadius={borderRadius}
      borderWidth={borderWidth}
      paddingHorizontal={10}
    >
      {children}
    </AbyssButton>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  color: PropTypes.string,
  colorHover: PropTypes.string,
  linkColor: PropTypes.string,
  altColor: PropTypes.string,
  altColorHover: PropTypes.string,
  borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  borderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Button.defaultProps = {
  children: null,
  variant: 'solid',
  color: 'UHC_BLUE',
  colorHover: 'UHC_CTA_BLUE',
  linkColor: 'UHC_CTA_BLUE',
  altColor: 'UHC_WHITE',
  altColorHover: 'UHC_BRIGHT_BLUE_10',
  borderRadius: '24px',
  borderWidth: 2,
};
